import { call, put, select } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IDataSourceDetailInfo } from '../../../../ts/models/IDataSourceInfo';
import {
  ChangeDatasourceRemoteRefreshPropertiesAction
} from '../../../../ts/services/ChangeDatasourceRemoteRefreshPropertiesAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import {
  SetRemoteExtractRefreshPropertiesAction
} from '../../../actions/spaces/SetRemoteExtractRefreshPropertiesAction';
import { selectContentTotalLength } from '../../../selectors/ContentSelectors';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleSetRemoteRefreshPropertiesAction(action: SetRemoteExtractRefreshPropertiesAction) {
  try {
    const refreshScheduleCount = yield select(selectContentTotalLength);
    yield call(executeSetRemoteRefreshPropertiesAction, action.datasource, refreshScheduleCount);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeSetRemoteRefreshPropertiesAction(
  datasource: IDataSourceDetailInfo,
  refreshScheduleCount: number
) {
  const setRemoteRefreshPropertiesService
      = ServiceLocator.get<ChangeDatasourceRemoteRefreshPropertiesAction>('ChangeDatasourceRemoteRefreshPropertiesAction');
  return setRemoteRefreshPropertiesService.execute(datasource, refreshScheduleCount);
}
